import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing

export default function ServicesPage({ services }) {
  return (
    <>
      {/* Services Page Start */}
      <section className="services-page">
        <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">WHAT WE DO</span>
          </div>
          <h2 className="section-title__title">
          Services <span>We Offer</span>
          </h2>
        </div>
          <div className="row">
            {services.map((service, index) => (
              <div key={index} className="col-xl-4">
                <div className="services-one__single">
                  <div className="services-one__img-box">
                    <div className="services-one__img">
                      <img src={service.imgSrc} alt={service.title} />
                    </div>
                    <div className="services-one__icon">
                      <span className={service.iconClass} />
                    </div>
                  </div>
                  <div className="services-one__content">
                    <h3 className="services-one__title">
                      <Link to={service.link}>{service.title}</Link>
                    </h3>
                    <p className="services-one__text">{service.description}</p>
                    <div className="services-one__btn-box">
                      <Link to={service.link} className="services-one__btn thm-btn">
                        Read more
                        <span className="icon-dubble-arrow-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Services Page End */}
    </>
  );
}
